import { render, staticRenderFns } from "./CalendarGenral.vue?vue&type=template&id=ed84a2ba&"
import script from "./CalendarGenral.vue?vue&type=script&lang=js&"
export * from "./CalendarGenral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports